
import Bill from "../../../assets/filled/Bill.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function BillIcon({ className, dataTestid = "BillIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Bill data-testid={dataTestid} className={classes} {...rest} />
  );
}
